export default __webpack_public_path__ + "static/verdesPorUnDia-49b9a093149a5ecef53458dbbb69c5ad.png";